import Places from 'constants/places'

const FLIGHT_DEAL_ORIGIN_CITY_PLACE_IDS: Record<string, string> = {
  ADL: Places.Adelaide.id,
  AKL: Places.Auckland.id,
  AVV: Places.Melbourne.id,
  BNE: Places.Brisbane.id,
  CBR: Places.Canberra.id,
  CHC: Places.Christchurch.id,
  DRW: Places.Darwin.id,
  HBA: Places.Hobart.id,
  MEL: Places.Melbourne.id,
  OOL: Places.GoldCoast.id,
  PER: Places.Perth.id,
  SYD: Places.Sydney.id,
  WLG: Places.Wellington.id,
}

export function getFlightDealOriginCityPlaceId(airportCode: string): string | undefined {
  return FLIGHT_DEAL_ORIGIN_CITY_PLACE_IDS[airportCode]
}
